import {Search} from '@mui/icons-material';
import WithEtsyAccount from '../../../pages/etsy/WithEtsyAccount';
import {FeatureObject} from '../../../types/FeatureObject';
import {FeatureStatus} from '../../../types/FeatureStatus';
import {HelpTutorialEnum} from '../../../variables/helpTutorial';
import EtsyBulkCreateCsv from './EtsyBulkCreateCsv';

export const etsyBulkCreateCsv: FeatureObject = {
  type: 'feature',
  title: 'Bulk Create Listings with CSV',
  description: 'Bulk create listings from a CSV file. This is only for creating new listings',
  IconComponent: Search,
  showFeatureFrontPage: true,
  path: '/etsyBulkCreateCsv',
  component: (user) => (
    <WithEtsyAccount
      featureName="Bulk Create Listings with CSV"
      helpTutorialEnum={HelpTutorialEnum.ETSY_BULK_CREATE_LISTINGS_WITH_CSV}
      component={(selectedAccount) =>
        selectedAccount ? <EtsyBulkCreateCsv selectedAccount={selectedAccount} user={user} /> : null
      }
    />
  ),
  status: FeatureStatus.PROD,
  tags: ['etsy', 'bulk', 'create', 'listings', 'csv'],
};
